import React, { useEffect, useState } from 'react';
import SgsstTabs from './SgsstTabs';
import { S, F, Grid, Modal, useFlash, fdate, dateVal } from './sgsstUi';

// Página CRUD genérica para las entidades planas del SG-SST.
// props:
//  title, sub, api ({list,create,update,remove}), vacio (form inicial),
//  columns: [{k, h, w?, map?, fmt?, mono?}]
//  fields:  [{k, l, type: text|number|date|datetime|select|textarea|bool, opts?, full?}]
//  hideTabs? (para usar embebido, ej. en Brigadas)
export default function SgsstCrudPage({ title, sub, api, vacio, columns, fields, hideTabs, newLabel = '+ Nuevo' }) {
  const [lista, setLista] = useState([]);
  const [m, setM] = useState(null);
  const [msgNode, flash] = useFlash();
  const [busy, setBusy] = useState(false);

  const load = () => api.list().then(r => setLista(r.data)).catch(() => {});
  useEffect(() => { load(); /* eslint-disable-next-line */ }, []);

  const dateKeys = fields.filter(f => f.type === 'date' || f.type === 'datetime').map(f => f.k);
  const toForm = (r) => { const f = { ...vacio, ...r }; dateKeys.forEach(k => { f[k] = dateVal(r[k]); }); return f; };

  const set = (k, v) => setM({ ...m, form: { ...m.form, [k]: v } });
  const guardar = async () => {
    setBusy(true);
    try { if (m.id) await api.update(m.id, m.form); else await api.create(m.form); setM(null); load(); flash(true, '✅ Guardado'); }
    catch (e) { flash(false, '❌ ' + (e.response?.data?.error || 'No se pudo')); } finally { setBusy(false); }
  };
  const borrar = async (r) => { if (!window.confirm('¿Eliminar el registro?')) return; try { await api.remove(r.id); load(); } catch (e) {} };

  const cell = (r, c) => {
    let v = r[c.k];
    if (c.fmt === 'date') v = fdate(v);
    else if (c.fmt === 'money') v = '$' + Number(v || 0).toLocaleString('es-CO');
    else if (c.fmt === 'bool') v = v ? '✔' : '—';
    else if (c.map) v = c.map[r[c.k]] || r[c.k];
    return v ?? '—';
  };

  const field = (fl) => {
    const v = m.form[fl.k];
    if (fl.type === 'select') return <select style={S.in} value={v ?? ''} onChange={e => set(fl.k, e.target.value)}>{fl.opts.map(([val, l]) => <option key={val} value={val}>{l}</option>)}</select>;
    if (fl.type === 'bool') return <select style={S.in} value={v ? '1' : '0'} onChange={e => set(fl.k, e.target.value === '1')}><option value="1">Sí</option><option value="0">No</option></select>;
    if (fl.type === 'textarea') return <textarea style={S.ta} value={v ?? ''} onChange={e => set(fl.k, e.target.value)} />;
    if (fl.type === 'number') return <input type="number" step={fl.step || '1'} style={S.in} value={v ?? ''} onChange={e => set(fl.k, e.target.value === '' ? '' : +e.target.value)} />;
    if (fl.type === 'date') return <input type="date" style={S.in} value={v || ''} onChange={e => set(fl.k, e.target.value)} />;
    if (fl.type === 'datetime') return <input type="datetime-local" style={S.in} value={v || ''} onChange={e => set(fl.k, e.target.value)} />;
    return <input style={S.in} value={v ?? ''} onChange={e => set(fl.k, e.target.value)} />;
  };

  return (
    <div style={S.wrap}>
      {!hideTabs && <SgsstTabs />}
      <div style={S.head}>
        <div><h1 style={S.h1}>{title}</h1>{sub && <p style={S.sub}>{sub}</p>}</div>
        <button style={S.btn} onClick={() => setM({ form: { ...vacio } })}>{newLabel}</button>
      </div>
      {msgNode}
      <div style={S.card}><div style={{ overflowX: 'auto' }}>
        <table style={S.table}>
          <thead><tr>{columns.map(c => <th key={c.k} style={S.th}>{c.h}</th>)}<th style={S.th}></th></tr></thead>
          <tbody>
            {lista.length === 0 && <tr><td colSpan={columns.length + 1} style={S.empty}>Sin registros.</td></tr>}
            {lista.map(r => (
              <tr key={r.id}>
                {columns.map(c => <td key={c.k} style={{ ...S.td, ...(c.mono ? { fontFamily: 'ui-monospace' } : {}), ...(c.strong ? { color: '#e2e8f0', fontWeight: 600 } : {}) }}>{cell(r, c)}</td>)}
                <td style={S.td}><button style={S.link} onClick={() => setM({ id: r.id, form: toForm(r) })}>Editar</button><button style={{ ...S.link, color: '#fca5a5' }} onClick={() => borrar(r)}>Eliminar</button></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div></div>

      {m && <Modal title={m.id ? 'Editar' : title} onClose={() => setM(null)} wide>
        <Grid cols={2}>
          {fields.map(fl => <div key={fl.k} style={fl.full ? { gridColumn: '1 / -1' } : {}}><F l={fl.l}>{field(fl)}</F></div>)}
        </Grid>
        <div style={S.modalBtns}><button style={S.btnGhost} onClick={() => setM(null)}>Cancelar</button><button style={S.btn} disabled={busy} onClick={guardar}>{busy ? 'Guardando…' : 'Guardar'}</button></div>
      </Modal>}
    </div>
  );
}
